import React from 'react';

export default function FormatError(error) {
    if (typeof error === 'string') {
        return <span style={{ color: 'red' }}>{error}</span>;
    }
    return <pre style={{ color: 'red' }}>{JSON.stringify(error, null, 4)}</pre>;
}